// extracted by mini-css-extract-plugin
module.exports = {"lightText":"LrvText_lightText__YTSrK","darkText":"LrvText_darkText__2cwyd"};